// @ts-nocheck

import React, { useEffect, useState, createContext } from 'react'
import { ApolloProvider } from '@apollo/client'
import { getClient } from 'apollo/configuration'

export const APP_ID = 398

enum Environment {
  LOCAL = 'local',
  KTAHILRAMANI = 'ktahilramani',
  WCHO = 'wcho',
  NMAMILLA = 'nmamilla',
  DEV = 'dev',
  EXT = 'ext',
  UAT = 'uat',
  PROD = 'prod',
}

interface LandscapeConfigResponse {
  announcement: {
    message: string
    after: number | null
  }
  login: {
    disable: boolean
    after: number | null
  }
  env: Environment[]
}

interface LandscapeConfig {
  announcement: string
  disableLogin: boolean
}

const ConfigContext = createContext<LandscapeConfig>({
  announcement: '',
  disableLogin: false,
})

const getEnvironment = () => {
  const host = window.location.hostname

  switch (host) {
    case 'landscape.collegeboard.org':
      return Environment.PROD
    case 'local-ecd.collegeboard.org':
      return Environment.LOCAL
    case 'tecd-uat.tecd-nonprod.collegeboard.org':
      return Environment.UAT
    case 'tecd-ext.tecd-nonprod.collegeboard.org':
      return Environment.EXT
    case 'tecd-ktahilramani.tecd-nonprod.collegeboard.org':
      return Environment.KTAHILRAMANI
    case 'tecd-wcho.tecd-nonprod.collegeboard.org':
      return Environment.WCHO
    case 'tecd-nmamilla.tecd-nonprod.collegeboard.org':
      return Environment.NMAMILLA
    default:
      return Environment.PROD
  }
}

const shouldUseConfig = (after: number | null) => {
  const getCurrentDateInGMT = () => {
    const now = new Date()
    const nowGMT = new Date(now.toISOString())
    return nowGMT
  }

  if (!after) {
    return true
  }

  const afterDateTime = new Date(after)
  const currentDateTime = getCurrentDateInGMT()
  return currentDateTime > afterDateTime
}

const AppProvider: React.FC = ({ children }) => {
  const client = getClient()
  const [config, setConfig] = useState({
    announcement: '',
    disableLogin: false,
  })

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    const configParam = queryParams.get('config')

    if (configParam === 'off') {
      setLoading(false)
      return
    }

    fetch('https://cb-tecd-prod-doc.s3.amazonaws.com/public/messaging.json')
      .then((res) => {
        if (res.ok) {
          res.json().then((data: LandscapeConfigResponse) => {
            if (data.env.includes(getEnvironment())) {
              let newConfig = config

              if (data.announcement.message && shouldUseConfig(data.announcement.after)) {
                newConfig.announcement = data.announcement.message
              }

              if (data.login.disable && shouldUseConfig(data.login.after)) {
                newConfig.disableLogin = data.login.disable
              }

              setConfig(newConfig)
            }
            setLoading(false)
          })
        } else {
          setLoading(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }, [])

  if (loading) return null

  return (
    <ApolloProvider client={client}>
      <ConfigContext.Provider value={config}>
        <cbw-header
          app-id={APP_ID}
          site-title="Landscape"
          program-type="corporate"
          use-search-widget="false"
          skip-target-id="main-content"
          use-login-widget={!config.disableLogin}
        />
        {children}
        <cbw-footer show-back-to-top="true" remove-top-margin="true" />
      </ConfigContext.Provider>
    </ApolloProvider>
  )
}

export { AppProvider, ConfigContext }
